// Normalises a URL or path into a low-cardinality *route template* for metric
// labels — e.g. `/event/4uWsZrUFFOmRsWUM/jobs?x=1` → `/event/:id/jobs`.
//
// Client-observed telemetry (soft-navigation timing, API request latency) labels
// series by route. Without templating, every id-bearing path becomes its own
// Prometheus series and cardinality explodes. Heldenarbeit ids are nanoid-style
// (mixed-case alphanumeric with `-`/`_`, ~12–16 chars); we also collapse numeric
// and UUID segments.

function isIdSegment(seg: string): boolean {
  if (seg === "") return false;
  if (/^\d+$/.test(seg)) return true; // numeric id
  if (/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-/.test(seg)) return true; // uuid
  // nanoid-style: reasonably long and clearly not a word (has a digit, or mixes
  // case, or carries an id separator).
  if (seg.length >= 8 && (/\d/.test(seg) || /[-_]/.test(seg) || (/[a-z]/.test(seg) && /[A-Z]/.test(seg)))) {
    return true;
  }
  return false;
}

/** Return the templated pathname of `input` (a URL or a path). Never throws. */
export function templateRoute(input: string): string {
  let path = input;
  try {
    const base = typeof window !== "undefined" ? window.location.origin : "http://localhost";
    path = new URL(input, base).pathname;
  } catch {
    // Fall back to stripping any query/hash by hand.
    path = input.split(/[?#]/)[0] ?? input;
  }
  const templated = path
    .split("/")
    .map((seg) => (isIdSegment(seg) ? ":id" : seg))
    .join("/");
  return templated || "/";
}
